import { Box, getThemeColor, getThemeSpacing } from '@fairfashion/design-system'
import { styled } from 'styled-components'

import {
  DashboardCard,
  DashboardPercentageCard,
} from '../../components/DashboardCards'

export const LeftColumn = styled(Box)`
  flex: 1;
  flex-direction: column;
  gap: ${({ theme }) => getThemeSpacing(3, theme)};

  @media (max-width: 1000px) {
    width: 100%;
  }
`

export const RightColumn = styled(Box)`
  width: 35%;

  @media (max-width: 1000px) {
    width: 100%;
  }
`

export const InvoicesCard = styled(Box)`
  padding: ${({ theme }) => getThemeSpacing(3, theme)};
  border-radius: ${({ theme }) => theme.border_radius.card};
  box-shadow: ${({ theme }) => theme.box_shadow.card};
  background-color: ${({ theme }) => getThemeColor('white', theme)};
  width: 100%;
  border: 1px solid ${({ theme }) => getThemeColor('grey_5', theme)};
`

export const IconContainer = styled(Box)`
  border: 1px solid ${({ theme }) => getThemeColor('grey_5', theme)};
  border-radius: 16px;
  height: 88px;
  width: 88px;
  justify-content: center;
  align-items: center;
`

export const Card = styled(DashboardCard)`
  flex: 1 1 200px;
`

export const CustomPercentageCard = styled(DashboardPercentageCard)`
  flex: 1.8 1 280px;
`

export const CustomText = styled(Box)`
  @media (max-width: 624px) {
    justify-content: flex-start;
  }
`
